@if (articleResult$ | async; as articleResult) {

    @if (articleResult.articles[0]; as body) {

        <app-plan-view [plan]="body.plan" [instrumentIDLookup]="body.instrumentIDLookup" [classesLookup]="body.classesLookup" [treatmentColumnVisibility]="body.treatmentColumnVisibility"></app-plan-view>
    
}

}
